<template>
  <section class="pb-3 pb-md-0">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center mb-5 d-flex justify-content-center">
          <span class="highlight highlight-blue-400">
            Toutes mes entreprises</span>
        </div>
        <div
          class="col-12 col-md-10 mx-auto"
        >
          <span>
            <button
              type="button"
              class="selected current  border-0 px-4 d-flex w-100"
              style="min-height: 78px; border-radius: 45px;"
            >
              <span>{{ current.name }} - {{ current.siret }}</span>
              <span class="me-2 mt-1 text-end fw-bold">Connecté</span>
              <font-awesome-icon
                class="d-flex m-auto p-1 cursor-pointer"
                icon="check"
                style="width: 32px; height: 32px;"
              />
            </button>
          </span>
          <div class="divider" />
          <transition-group name="flip-list">
            <v-account-company-display
              v-for="company in allCompanies"
              :key="company.id"
              :company="company"
              class="mb-2 connecter"
              @error="(value) => error = value"
            />
          </transition-group>
        </div>
      </div>
      <div class="col-12 col-md-10 mt-5 mx-auto d-flex">
        <v-loader
          :next="() => $router.push('/client/account/companies')"
          title="Gèrer vos entreprises"
          icon="gear"
          class="w-50"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import CompanySwitchDisplay from '../../components/account/helpers/CompanySwitchDisplay.vue';

export default {
  name: 'AccountsCompanies',
  components: {
    'v-account-company-display': CompanySwitchDisplay,
  },
  computed: {
    ...mapGetters({
      additionalCompanies: 'client/additionalCompanies',
      current: 'company/get',
    }),
    allCompanies() {
      const allCompanies = [];
      if (this.additionalCompanies && this.additionalCompanies.length > 0) {
        for (let i = 0; i < this.additionalCompanies.length; i += 1) {
          allCompanies.push(this.additionalCompanies[i]);
        }
      }
      return allCompanies;
    },
  },
};
</script>

<style>
.selected {
  background-color: rgba(27, 213, 27, 0.14);

}
.current {
  display: flex;
  align-items: center;
  font-weight: 900;
  pointer-events: none;
}

.divider {
  margin: 10px;
  height: 10px;
}

.current {
    min-height: 78px;
    border-radius: 45px;
  }

  .current span {
    flex: 1;
    text-align: justify;
  }

  .cursor-pointer {
    cursor: pointer;
  }

</style>
